import { Component, OnInit, Input, TemplateRef, ViewChild, OnChanges, ElementRef } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { ContentQuestionObj } from '../contentQuestion';
import { TrainingContentObj } from '../trainingContent';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from 'src/app/PaginationService';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { messageService } from 'src/app/message.service';
import { Router } from '@angular/router';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { SessionTimeoutService } from 'src/app/session-timeout-dialog/session-timeout.service';

@Component({
  selector: 'app-training-content',
  templateUrl: './training-content.component.html',
  styleUrls: ['./training-content.component.scss']
})
export class ContentDialogComponent implements OnInit, OnChanges {

  @Input() trainingData: any = {};
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  contentList: TrainingContentObj[] = [];
  isFileValid = false;
  contentData: TrainingContentObj = {};
  isProcessing = false;
  searchValue: string = '';
  operationFlag: any;
  previousContentData: any = {};
  clearedContentFile = false;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  isQuestionContent = false;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  contentFile: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  isShowQuestionGrid = false;
  isShowOptionsGrid = false;
  title = "";
  contentFrom = "";
  _temp: any = {};
  columnLists: any = {};
  trainingContentsDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleAddOrEditContentPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteContentPopup: MatDialogRef<TemplateRef<any>>;
  visibleReorderContentPopup: MatDialogRef<TemplateRef<any>>;
  visibleAddDocumentPopup: MatDialogRef<TemplateRef<any>>;
  visibleSwitchConfirmPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditContentPopup', { static: true }) addOrEditContentPopup: TemplateRef<any>;
  @ViewChild('deleteContentPopup', { static: true }) deleteContentPopup: TemplateRef<any>;
  @ViewChild('reorderContentPopup', { static: true }) reorderContentPopup: TemplateRef<any>;
  @ViewChild('addDocumentPopup', { static: true }) addDocumentPopup: TemplateRef<any>;
  @ViewChild('switchConfirmPopup', { static: true }) switchConfirmPopup: TemplateRef<any>;
  addOrEditContentPopupConfig = {
    width: '100%',
    height: 'auto',
    minHeight: '250px',
    maxHeight: '90vh',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px' }
  };


  addDocumentPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteContentPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  switchConfirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  reorderContentPopupConfig = {
    width: '700px',
     minheight: '40vh',
    maxheight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  constructor(private readonly appService: AppService, private readonly snackBar: MatSnackBar, public paginationService: PaginationService,
    public dialog: MatDialog, public message: messageService, private readonly elem: ElementRef, private readonly router: Router, private readonly sessionTimeoutService: SessionTimeoutService) {

  }

  trainingContentExtns: any = "*.*"
  tmsSettingsObj: any = {};
  ngOnInit(): void {
    this.appService.getTmsSettingsVwDetails().subscribe((response: any) => {
      if (response) {
        this.tmsSettingsObj = response;
        if (response.trainingContentExtns != null) {
          this.trainingContentExtns = null;
          let extns = response.trainingContentExtns.split(",");
          for (const element of extns) {
            this.trainingContentExtns = this.trainingContentExtns == null ? "." + element.toLowerCase() : this.trainingContentExtns + "," + "." + element.toLowerCase();
          }

        }
      } else {
        this.tmsSettingsObj = {};
      }
    });
  }

  ngOnChanges() {
    this.getcallMethod();
  }

  isibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';


  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        throw error;
      }
    })
    this.isProcessing = false;

  }

  htmlContent: any;



  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.trainingContentsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.trainingContentsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.trainingContentsDataForGrid = [];
    const data = {

      gridName: "TRAINING_CONTENTS"
    }
    this.isProcessing = true;
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "TMS_TRAINING_CONTENTS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          trainingId: this.trainingData['trainingId'].toString(),
          version: this.trainingData['version'].toString(),
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.auditTrail.reportObj = this.reportObj = { ...data, ...data1 };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.trainingContentsDataForGrid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }
                for (const element of this.trainingContentsDataForGrid) {
                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType === 'CHECKBOX') {
                      element[dataType.columnName] = element[dataType.columnName] === "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              }, error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
            this.message.gridList = this.trainingContentsDataForGrid;
            this.collectionSize = this.trainingContentsDataForGrid.length;
            this.totalPages = Math.ceil(this.trainingContentsDataForGrid.length / this.itemsPerPage);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }



  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.trainingContentsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.trainingContentsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.trainingContentsDataForGrid) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of this.trainingContentsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.trainingContentsDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.CONTENT_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.trainingContentsDataForGrid.some((list: any) => list.childCheckBoxs);
    this.priviousSelectedValue = idx;
  }

  cancelViewPopup() {
    this.visibleViewPopup.close();
  }


  addContentFunc() {
    this.contentData = {};
    this.contentData['contentName'] = "";
    this.contentData['contentDescription'] = "";
    this.contentData['waitTimeInMins'] = "";
    this.contentData['totalDuration'] = "";
    this.contentData['isQuestionContent'] = false;
    this.contentData['passPercentage'] = "";
    this.contentData['noOfQuestionsForAssessment'] = "";
    this.contentFile = null;
    this.contentData['documentId'] = "";
    this.contentData['documentNo'] = "";
    this.contentData['documentVersion'] = "";
    this.contentData['documentName'] = "";
    this.contentData['contentExtn'] = "";
    this.contentData['isQuestionContent1'] = "";
    this.contentData['contentFile'] = null;
    this.contentData['questionCount'] = 0;
    this.contentFrom = "";
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.clearedContentFile = false;
    this.isUploadDocManually = false;
    this.isUploadDocRepository = false;
    this.title = "Add Content";
    this.isFileValid = true;
    this.isShowOptionsGrid = false;
    this.isShowQuestionGrid = false;
    this.isShowAssessmentFields = false;
    this.isShowDocumentFields = false;
    this.isQuestionContent = false;
    this.visibleAddOrEditContentPopup = this.dialog.open(this.addOrEditContentPopup, this.addOrEditContentPopupConfig);
  }


  editContentFunc(content: any) {
    this.isProcessing = true;
    this.appService.getContentByContentId(content.CONTENT_ID,
      content.TRAINING_ID, content.VERSION).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.contentData = data[0];
          this.contentData.saveButtonForTraining = this.trainingData.saveButtonForTraining;
          this.contentData['isQuestionContent'] = this.contentData['isQuestionContent'] == "Y";
          this.isQuestionContent = this.contentData['isQuestionContent'];
          this.contentFile = this.contentData['contentFile'];
          if (this.contentData['isQuestionContent']) {
            this.isShowAssessmentFields = true;
            this.isShowQuestionGrid = true;
            this.isShowDocumentFields = false;
            this.isFileValid = true;
            this.contentData['isQuestionContent1'] = "Is Question Content?"
            this.isUploadDocManually = false;
            this.isUploadDocRepository = false;
          } else {
            this.isFileValid = true;
            this.clearedContentFile = false;
            this.isShowQuestionGrid = false;
            this.isShowOptionsGrid = false;
            this.isShowAssessmentFields = false;
            this.isShowDocumentFields = true;
            this.contentData['isQuestionContent1'] = "Document"


            if (this.contentData['contentFile'] != null) {
              this.isUploadDocManually = true;
              this.isUploadDocRepository = false;
              this.contentFrom = "Manually";
              this.contentFile = this.contentData['contentFile'];
            } else if (this.contentData['documentId'] != null) {
              this.isUploadDocManually = false;
              this.isUploadDocRepository = true;
              this.contentFrom = "Document Repository";
            }
          }
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });

    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = "Update Content";
    this.visibleAddOrEditContentPopup = this.dialog.open(this.addOrEditContentPopup, this.addOrEditContentPopupConfig);
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    this.isFileValid = false;
    if (file) {
      this.contentFile = file;
      this.clearedContentFile = false;
      this.contentData.contentExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      if (this.trainingContentExtns.includes(this.contentData.contentExtn)) {
        let name = file.name.substring(0, file.name.lastIndexOf('.'));
        let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
        const formData = new FormData();
        formData.append('file', file ?? '');
        formData.append("pageName", "TMS");
        formData.append("fileName", name);
        formData.append("extension", extension);
        this.isProcessing = true;
        this.appService.fileUploadToServer(formData)
          .subscribe({
            next: (data: any) => {
              this.isProcessing = false;
              if (data.resultType == "S") {
                this.isFileValid = true;

              } else {
                this.isFileValid = false;
                this.contentFile = null;
                this.contentData.contentExtn = '';
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: data.result,
                    type: data.resultType == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.resultType == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
              }
            }, error: (error) => {
              this.displayMessage = error;
              this.displaySuccessMessage = false;
              this.displayErrorMessage = true;
              this.isProcessing = false;
              throw error;
            }
          })
      } else {
        let warningMsgType = "E";
        let warningMsg = this.contentData.contentExtn + " file type is not allowed, please choose allowed file type.";
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: warningMsg,
            type: warningMsgType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: warningMsgType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }
    } else {
      this.contentFile = '';
      this.contentData.contentExtn = '';
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddOrEditContentPopup.close();
    this.getcallMethod();
  }

  addAndEditFunction(contentData: any) {
    // 1. Check File Validity
    if (!this.isFileValid) {
      alert("File is empty or not valid, please choose different file.");
      this.stopProcessing();
      return;
    }

    this.isProcessing = true;

    // 2. Validate Form Inputs
    if (this.isInputInvalid(contentData)) {
      this.fieldValidation();
      this.isProcessing = false;
      return;
    }
    this.sanitizeContentData(contentData);
    // 3. Prepare Data and FormData
    this.prepareContentDataForSave(contentData);
    const formData = this.createFormData(contentData);

    // 4. API Call
    this.appService.addOrUpdateTrainingContent(formData).subscribe(
      {
        next: (data: any) => this.handleSaveSuccess(data, contentData),
        error: (error: any) => this.handleSaveError(error)
      });
  }

  private isInputInvalid(contentData: any): boolean {
    const isNameEmpty = !contentData['contentName'];

    const isInvalidAssessment = this.isShowAssessmentFields &&
      (
        contentData.passPercentage == null ||
        contentData.passPercentage === '' ||
        contentData.passPercentage <= 0 ||
        contentData.passPercentage > 100||
        contentData.noOfQuestionsForAssessment == null ||
        contentData.noOfQuestionsForAssessment === '' ||
        contentData.noOfQuestionsForAssessment <= 0
      );

    return isNameEmpty || isInvalidAssessment;
  }

  private prepareContentDataForSave(contentData: any) {
    if (this.operationFlag == "ADD") {
      contentData['operation'] = "I";
    } else {
      contentData['operation'] = "U";
      delete contentData['createdOn'];
      delete contentData['updatedOn'];
      if (contentData['documentId'] != null && contentData['documentId'] != undefined) {
        contentData['contentExtn'] = null;
      }
    }


    contentData['trainingId'] = this.trainingData['trainingId'];
    contentData['version'] = this.trainingData['version'];
    contentData['isQuestionContent'] = this.isQuestionContent ? "Y" : "N";
  }

  private createFormData(contentData: any): FormData {
    const formData = new FormData();
    formData.append('file', this.contentFile);
    const json = JSON.stringify(contentData);
    const blob = new Blob([json], { type: 'application/json' });
    formData.append('trainingContentDto', blob);
    return formData;
  }

  private handleSaveSuccess(data: any, contentData: any) {
    this.isProcessing = false;

    if (data.resultType == "S") {

      this.resetValidationUI();

      if (this.contentData['isQuestionContent'] == "N") {
        this.visibleAddOrEditContentPopup.close();
        this.getcallMethod();
      } else {
        this.refreshAssessmentData(data.contentId);
      }
      this.operationFlag = "EDIT";
    }

    this.showSnackBar(data.result, data.resultType);
    this.stopProcessing();
  }

  private resetValidationUI() {
    const contentName = document.getElementById('contentName');
    const contentNameMsg = document.getElementById('contentName-required-msg');
    if (contentName) contentName.style.border = '';
    if (contentNameMsg) contentNameMsg.style.display = 'none';

    const questionNo = document.getElementById('noOfQuestions');
    const questionMsg = document.getElementById('questions-required-msg');
    if (questionNo) questionNo.style.border = '';
    if (questionMsg) questionMsg.style.display = 'none';

    const passPercent = document.getElementById('passPercentage');
    const passPercentMsg = document.getElementById('passPercentage-required-msg');
    if (passPercent) passPercent.style.border = '';
    if (passPercentMsg) passPercentMsg.style.display = 'none';
  }

  private refreshAssessmentData(contentId: any) {
    this.appService.getContentByContentId(contentId,
      this.trainingData.trainingId,
      this.trainingData.version
    ).subscribe({
      next:
        (data: any) => {
          this.contentData = data[0];
          this.contentData.saveButtonForTraining = this.trainingData.saveButtonForTraining;

          if (this.fileUploadPath) {
            this.saveQuestionsFromFile();
          } else {
            this.updateAssessmentUIState();
          }
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
    }
    );
  }

  private updateAssessmentUIState() {
    this.contentData['isQuestionContent'] = this.contentData['isQuestionContent'] == "Y";
    this.isQuestionContent = this.contentData['isQuestionContent'];

    if (this.contentData['isQuestionContent']) {
      this.isShowQuestionGrid = true;
      this.isShowOptionsGrid = false;
      this.isShowAssessmentFields = true;
      this.isShowDocumentFields = false;
      this.contentData['isQuestionContent1'] = "Is Question Content?";
    } else {
      this.isShowQuestionGrid = false;
      this.isShowOptionsGrid = false;
      this.isShowAssessmentFields = false;
      this.isShowDocumentFields = true;
      this.contentData['isQuestionContent1'] = "Document";
      this.updateDocumentUploadState();
    }

    this.visibleAddButton = false;
    this.visibleEditButton = true;
  }

  private updateDocumentUploadState() {
    if (this.contentData['contentFile'] != null) {
      this.isUploadDocManually = true;
      this.isUploadDocRepository = false;
      this.contentFrom = "Manually";
    } else if (this.contentData['documentId'] != null) {
      this.isUploadDocManually = false;
      this.isUploadDocRepository = true;
      this.contentFrom = "Document Repository";
    }
  }

  private handleSaveError(error: any) {
    this.displayMessage = error;
    this.displaySuccessMessage = false;
    this.displayErrorMessage = true;
    this.isProcessing = false;
    throw error;
  }

  private showSnackBar(message: string, type: string) {
    let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000,
      data: {
        message: message,
        type: type == 'S' ? 'Success' : 'Error',
        buttonLabel: "Ok"
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type == 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  private stopProcessing() {
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }
  saveQuestionsFromFile() {
    let data = {
      trainingId: this.contentData.trainingId,
      version: this.contentData.version,
      contentId: this.contentData.contentId,
      filePath: this.fileUploadPath,
      fileName: this.fileName,
      fileExtn: this.fileExtension,
      mode: "CREATE"
    }
    this.appService.addQuestionsThroughFileUpload(data).subscribe({
      next: (data: any) => {
        this.isProcessing = false;

        this.contentData['isQuestionContent'] = this.contentData['isQuestionContent'] == "Y";
        this.isQuestionContent = this.contentData['isQuestionContent'];
        if (this.contentData['isQuestionContent']) {
          this.isShowQuestionGrid = true;
          this.isShowOptionsGrid = false;
          this.isShowAssessmentFields = true;
          this.isShowDocumentFields = false;
          this.contentData['isQuestionContent1'] = "Is Question Content?"
        } else {
          this.isShowQuestionGrid = false;
          this.isShowOptionsGrid = false;
          this.isShowAssessmentFields = false;
          this.isShowDocumentFields = true;
          this.contentData['isQuestionContent1'] = "Document"

          if (this.contentData['contentFile'] != null) {
            this.isUploadDocManually = true;
            this.isUploadDocRepository = false;
            this.contentFrom = "Manually";
          } else if (this.contentData['documentId'] != null) {
            this.isUploadDocManually = false;
            this.isUploadDocRepository = true;
            this.contentFrom = "Document Repository";
          }
        }
        this.visibleAddButton = false;
        this.visibleEditButton = true;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      }
    });
  }

  refreshContentGrid() {
    this.getcallMethod();
  }

  contentName: any;

  contentNameRequiredMsg: any;
  passPercent: any;
  passPercentMsg: any;

 fieldValidation() {
    // Content Name Validation (Always Checked)
    this.contentName = document.getElementById('contentName') as HTMLInputElement;
    this.contentNameRequiredMsg = document.getElementById('contentName-required-msg') as HTMLInputElement;

    if (this.contentData.contentName) {
      if (this.contentName) this.contentName.style.border = '';
      if (this.contentNameRequiredMsg) this.contentNameRequiredMsg.style.display = 'none';
    } else {
      if (this.contentName) this.contentName.style.border = '1px solid red';
      if (this.contentNameRequiredMsg) this.contentNameRequiredMsg.style.display = 'block';
    }

    //  Assessment Fields Validation
    if (this.isShowAssessmentFields) {
      
      // Pass Percentage Validation
      this.passPercent = document.getElementById('passPercentage') as HTMLInputElement;
      this.passPercentMsg = document.getElementById('passPercentage-required-msg') as HTMLInputElement;

      const isPassPercentageInvalid =
        this.contentData.passPercentage == null ||
        this.contentData.passPercentage === '' ||
        this.contentData.passPercentage <= 0 ||
        this.contentData.passPercentage > 100;

      if (isPassPercentageInvalid) {
        if (this.passPercent) this.passPercent.style.border = '1px solid red';
        if (this.passPercentMsg) this.passPercentMsg.style.display = 'block';
      } else {
        if (this.passPercent) this.passPercent.style.border = '';
        if (this.passPercentMsg) this.passPercentMsg.style.display = 'none';
      }

      //Number of Questions Validation
      const questionNo = document.getElementById('noOfQuestions') as HTMLInputElement;
      const questionMsg = document.getElementById('questions-required-msg') as HTMLInputElement;

      const isQuestionInvalid = 
        this.contentData.noOfQuestionsForAssessment == null || 
        this.contentData.noOfQuestionsForAssessment === '' || 
        this.contentData.noOfQuestionsForAssessment <= 0;

      if (isQuestionInvalid) {
        if (questionNo) questionNo.style.border = '1px solid red';
        if (questionMsg) questionMsg.style.display = 'block';
      } else {
        if (questionNo) questionNo.style.border = '';
        if (questionMsg) questionMsg.style.display = 'none';
      }
    }
  }

  isShowAssessmentFields: boolean = false;
  isShowDocumentFields: boolean = false;

  switchData: any;
  onTypeChanged(data: any) {
    this.switchData = data;
    let hasQuestions = false;
    
   if (this.contentData && this.contentData.questionCount && Number(this.contentData.questionCount) > 0) {
      hasQuestions = true;
    }else{hasQuestions = false;}

    if (this.switchData == "Is Question Content?") {
      if ((this.contentData.documentId != "" && this.contentData.documentId != null) || this.contentData.contentFile != null || this.contentFile) {
        this.switchMessage = "The content is of document type, please remove the document associated with the content before switching the type";
        this.visibleSwitchConfirmPopup = this.dialog.open(this.switchConfirmPopup, this.switchConfirmPopupConfig);
      } else {
        this.isQuestionContent = true;
        this.isShowAssessmentFields = true;
        this.isShowQuestionGrid = true;
        this.isShowDocumentFields = false;
        this.isUploadDocManually = false;
        this.isUploadDocRepository = false;
        if (this.contentData.contentId != null && this.contentData.contentId != undefined) {
          this.contentData['operation'] = "U";
          delete this.contentData['createdOn'];
          delete this.contentData['updatedOn'];
          this.contentData['trainingId'] = this.trainingData['trainingId'];
          this.contentData['version'] = this.trainingData['version'];
          this.contentData['isQuestionContent'] = this.isQuestionContent ? "Y" : "N";
          const formData = new FormData();
          formData.append('file', this.contentFile);
          const json = JSON.stringify(this.contentData);
          const blob = new Blob([json], {
            type: 'application/json'
          });
          formData.append('trainingContentDto', blob);
          this.appService.addOrUpdateTrainingContent(formData).subscribe({
            next: (data: any) => {
              this.isProcessing = false;
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });

              this.isProcessing = false;
            }, error: (error) => {
              this.displayMessage = error;
              this.displaySuccessMessage = false;
              this.displayErrorMessage = true;
              this.isProcessing = false;
              throw error;
            }
          });
        }
      }

    } else if (!hasQuestions) {
      this.isQuestionContent = false;
      this.isShowAssessmentFields = false;
      this.isShowQuestionGrid = false;
      this.isShowDocumentFields = true;
      this.isShowQuestionGrid = false;
      this.isShowOptionsGrid = false;

      if (this.contentFrom === "Manually") {
        this.isUploadDocManually = true;
        this.isUploadDocRepository = false;
      } else if (this.contentFrom === "Document Repository") {
        this.isUploadDocManually = false;
        this.isUploadDocRepository = true;
      }
    } else {
      this.switchMessage = "The content is of assessment type, please remove the questions associated with the content and click [Update] before switching the type";
      this.visibleSwitchConfirmPopup = this.dialog.open(this.switchConfirmPopup, this.switchConfirmPopupConfig);
    }
  }
  isUploadDocManually: boolean = false;
  isUploadDocRepository: boolean = false;


  onContentDocChanged(data: any) {
    this.switchData = data;
    if (data == "Manually") {
      if (this.contentData.documentId != "" && this.contentData.documentId != null) {
        this.switchMessage = "The document is of repository type, please remove the document associated with the content before switching the type";
        this.visibleSwitchConfirmPopup = this.dialog.open(this.switchConfirmPopup, this.switchConfirmPopupConfig);
      } else {
        this.isUploadDocManually = true;
        this.isUploadDocRepository = false;
      }

    } else if (this.contentFile || this.contentData.contentFile) {
      this.switchMessage = "The document is of manual type, please remove the document associated with the content before switching the type";
      this.visibleSwitchConfirmPopup = this.dialog.open(this.switchConfirmPopup, this.switchConfirmPopupConfig);
    } else {
      this.isUploadDocManually = false;
      this.isUploadDocRepository = true;
      this.clearedContentFile = true;
    }
  }


  removeFile() {
    this.clearedContentFile = true;
    this.contentFile = null;
    this.contentData['contentFile'] = null;
    this.contentData['contentExtn'] = "";
    this.contentData.documentId = null;
    this.contentData.documentNo = "";
    this.contentData.documentName = "";
    this.contentData.documentVersion = "";
  }

  validateNoOfQues(event: any) {
    if (event.key === 'e' || event.key === '-' || event.key === 'E' || event.key === '+' || event.key === '.') {
      event.preventDefault();
    }
  }

  validatePassPercentage(event: any) {
    let keyCode = event.which || event.keyCode;
    let currentValue = this.contentData['passPercentage'] || '';
    let newValue = String.fromCodePoint(keyCode);
    let combinedValue: any = currentValue + newValue;
    if (combinedValue < 1 || combinedValue > 100) {
      event.preventDefault();
    }
    if (event.key === 'e' || event.key === '-' || event.key === 'E' || event.key === '+' || event.key === '.') {
      event.preventDefault();
    }
  }

  validateWaitTime(event: any) {
    let keyCode = event.which || event.keyCode;
    let currentValue = this.contentData['waitTimeInMins'] || '';
    let newValue = String.fromCodePoint(keyCode);
    let combinedValue: any = currentValue + newValue;
    if (combinedValue < 0 || combinedValue > 59 || combinedValue.length > 2) {
      combinedValue.substring(1);
      event.preventDefault();
    }
    if (event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-' || event.key === '.') {
      event.preventDefault();
    }
  }

  questionData: ContentQuestionObj = {};
  model = {
    questionObj: {},
    isShowGrid: false
  };
  changeInChild(data: any) {
    this.model = data;
    this.isShowOptionsGrid = this.model.isShowGrid;
    this.questionData = this.model.questionObj;
    if (data.questionCount !== undefined) {
      this.contentData.questionCount = data.questionCount;
    } else if (data.questionList !== undefined) {
      this.contentData.questionCount = data.questionList.length;
    }
  }

  openDeletePopup(contentData: any) {
    this.appService.getContentByContentId(contentData.CONTENT_ID,
      contentData.TRAINING_ID, contentData.VERSION).subscribe((data: any) => {
        this.contentData = data[0];
        this.contentData.saveButtonForTraining = this.trainingData.saveButtonForTraining;
      })
    this.contentData['deleteReason'] = "";
    this.contentData['contentId'] = contentData.CONTENT_ID;
    this.contentData['trainingId'] = contentData.TRAINING_ID;
    this.contentData['version'] = contentData.VERSION;
    this.title = "Delete Content";
    this.visibleDeleteContentPopup = this.dialog.open(this.deleteContentPopup, this.deleteContentPopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeleteContentPopup.close();
  }

  deleteFunction() {
    this.isProcessing = true;
    if (this.contentData['deleteReason'] == "") {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      delete this.contentData['createdOn'];
      delete this.contentData['updatedOn'];
      this.appService.deleteTrainingContent(this.contentData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.deleteValidation();
            this.getcallMethod();
          }
          this.visibleDeleteContentPopup.close();
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  deleteReason: any;
  deleteReasonRequiredMsg: any;

  deleteValidation() {
    this.deleteReason = document.getElementById('deleteReason') as HTMLInputElement;

    this.deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

    if (this.contentData.deleteReason == "") {
      this.deleteReason.style.border = '1px solid red';
      this.deleteReasonRequiredMsg.style.display = 'block';
    } else {
      this.deleteReason.style.border = 'none';
      this.deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  omit_special_char(event: any) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  callReorderFunc() {
    this.title = "Reorder Content";
    this.isProcessing = true;
    this.appService.getContentsList(this.trainingData['trainingId'],
      this.trainingData['version']).subscribe((data: any) => {
        this.isProcessing = false;
        this.contentList = data;
        for (let i = 0; i < this.contentList.length; i++) {
          this.contentList[i].newSeq = i + 1;
        }
      })

    this.visibleReorderContentPopup = this.dialog.open(this.reorderContentPopup, this.reorderContentPopupConfig);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.contentList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.contentList.length; i++) {
      this.contentList[i].newSeq = i + 1;
    }
  }

  reorderContentFunction() {
    this.isProcessing = true;
    for (let i = 0; i < this.contentList.length; i++) {
      let data = {
        trainingId: this.contentList[i]['trainingId'],
        version: this.contentList[i]['version'],
        contentId: this.contentList[i]['contentId'],
        contentSeq: this.contentList[i]['newSeq'],
      }
      this.appService.reorderTrainingContent(data).subscribe((data: any) => {
        if (i == this.contentList.length - 1) {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleReorderContentPopup.close();
            this.getcallMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }
      })
    }
  }

  cancelReorderFunction() {
    this.visibleReorderContentPopup.close();
  }

  folderList: any = [];
  documentList: any = [];
  isShowDocumentGridForUpload: boolean = false;
  parentFolderId: any;
  folderId: any;
  searchValueForFolder: any;
  breadCrumbList: any = [];
  uploadDocFromDms() {
    this.parentFolderId = 0;
    this.folderId = 0;
    this.breadCrumbList = [];
    this.isShowDocumentGridForUpload = false;
    this.contentData.documentId = "";
    this.contentData.documentNo = "";
    this.contentData.documentName = "";
    this.contentData.documentVersion = "";
    this.selectedDMSdDoc = {};
    this.breadCrumbList.push("Root Folder");
    this.title = "Upload Content From Document Repository";
    this.visibleAddDocumentPopup = this.dialog.open(this.addDocumentPopup, this.addDocumentPopupConfig);
  }

  collectionSizeForFolder: number;
  perPageForFolder = 10;
  pagerForFolder: any = {};
  setPageForFolder(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pagerForFolder = this.paginationService.getPager(this.folderList.length, page, this.perPageForFolder, targetpage);
    this.folderList = this.folderList.slice(this.pagerForFolder.startIndex, this.pagerForFolder.endIndex + 1);
  }

  paginationCallForFolder(value: number) {
    this.pagerForFolder = value;
    this.setPageForFolder(this.pagerForFolder.currentPage, 0);
  }

  parentCheckBoxForFolder: boolean = false;
  childCheckBoxsForFolder: boolean = false;

  dataGridParentCheckBoxForFolderChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxsForFolder = true;
      for (const element of this.folderList) {
        element.childCheckBoxsForFolder = true;
      }

    } else {
      this.childCheckBoxsForFolder = false;
      for (const element of this.folderList) {
        element.childCheckBoxsForFolder = false;
      }
    }
  }

  dataGridChildCheckBoxForFolderChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxsForFolder = true;
    } else {
      list.childCheckBoxsForFolder = false;
    }
  }

  modelForDoc = {
    documentData: {},
  };
  selectedDMSdDoc: any = {};
  changeInFolderStructureChild(data: any) {
    this.modelForDoc = data;
    this.selectedDMSdDoc = this.modelForDoc.documentData;
  }

  addDocumentFromDmsFunction() {
    if (this.selectedDMSdDoc.documentId != undefined && this.selectedDMSdDoc.documentId != null) {
      this.clearedContentFile = false;
      this.contentData.documentId = this.selectedDMSdDoc.documentId;
      this.contentData.documentNo = this.selectedDMSdDoc.documentNo;
      this.contentData.documentVersion = this.selectedDMSdDoc.version;
      this.contentData.documentName = this.selectedDMSdDoc.documentName;
      this.visibleAddDocumentPopup.close();
    } else {
      alert("please select document!");
    }

  }

  cancelAddDocuemntFunction() {
    this.visibleAddDocumentPopup.close();
  }
  isSingleClick: boolean = true;
  doubleClickEvent(data: any) {
    this.isSingleClick = false;
    this.isShowDocumentGridForUpload = false;
    this.breadCrumbList.push(data.folderName);
    this.isProcessing = true;
    this.parentFolderId = this.folderId;
    this.folderId = data.folderId;
    this.appService.getDmsFolderList(this.folderId)
      .subscribe((data: any) => {
        this.folderList = data;
        this.isProcessing = false;
        this.collectionSizeForFolder = this.folderList.length;
      })
  }

  backToPreviousFolder() {
    this.breadCrumbList.pop();
    this.folderId = this.parentFolderId;
    if (this.parentFolderId == 0) {
      this.parentFolderId = 0;
      this.isProcessing = true;
      this.appService.getDmsFolderList(this.folderId)
        .subscribe((data: any) => {
          this.folderList = data;
          this.isProcessing = false;
          this.collectionSizeForFolder = this.folderList.length;
        })
    } else {
      this.appService.getDmsFolderDataById(this.parentFolderId)
        .subscribe((data: any) => {
          this.parentFolderId = data[0].parentFolderId;
          this.isProcessing = true;
          this.appService.getDmsFolderList(this.folderId)
            .subscribe((data: any) => {
              this.folderList = data;
              this.isProcessing = false;
              this.collectionSizeForFolder = this.folderList.length;
            })
        })
    }

  }

  openDocGridFunc(folder: any) {
    this.isSingleClick = true;
    setTimeout(() => {
      if (this.isSingleClick) {
        this.isShowDocumentGridForUpload = true;
        this.isProcessing = true;
        this.appService.getDocumentListForTraining(folder.folderId)
          .subscribe((data: any) => {
            this.documentList = data;
            this.isProcessing = false;
          })
      }
    }, 250)

  }

  searchValueForDocument: any;
  collectionSizeForDocument: number;
  perPageForDocument = 10;
  pagerForDocument: any = {};
  setPageForDocument(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pagerForDocument = this.paginationService.getPager(this.documentList.length, page, this.perPageForFolder, targetpage);
    this.documentList = this.documentList.slice(this.pagerForFolder.startIndex, this.pagerForFolder.endIndex + 1);
  }

  paginationCallForDocument(value: number) {
    this.pagerForDocument = value;
    this.setPageForDocument(this.pagerForDocument.currentPage, 0);
  }

  parentCheckBoxForDocument: boolean = false;
  childCheckBoxsForDocument: boolean = false;

  dataGridParentCheckBoxForDocumentChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxsForDocument = true;
      for (const element of this.documentList) {
        element.childCheckBoxsForDocument = true;
      }

    } else {
      this.childCheckBoxsForDocument = false;
      for (const element of this.documentList) {
        element.childCheckBoxsForDocument = false;
      }
    }
  }
  getSelectedDocumentId: any;
  getSelectedDocumentNo: any;
  getSelectedDocumentName: string;
  getSelectedDocumentVersion: any;
  dataGridChildCheckBoxForDocumentChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxsForDocument = true;
      this.getSelectedDocumentId = list.documentId;
      this.getSelectedDocumentNo = list.documentNo;
      this.getSelectedDocumentName = list.documentName;
      this.getSelectedDocumentVersion = list.version;
    } else {
      list.childCheckBoxsForDocument = false;
      this.getSelectedDocumentId = "";
      this.getSelectedDocumentNo = "";
      this.getSelectedDocumentName = "";
      this.getSelectedDocumentVersion = "";
    }
  }


  cancelSwitchFunction() {
    this.visibleSwitchConfirmPopup.close();
  }

  switchMessage: any;
  switchConfirmFunction() {
    if (this.switchData == "Manually") {
      this.contentFrom = "Document Repository";
    } else if (this.switchData == "Document Repository") {
      this.contentFrom = "Manually";
    } else if (this.switchData == "Is Question Content?") {
      this.contentData['isQuestionContent1'] = "Document"
    } else if (this.switchData == "Document") {
      this.contentData['isQuestionContent1'] = "Is Question Content?"
      this.isQuestionContent = true;
    }
    this.visibleSwitchConfirmPopup.close();
  }

  @ViewChild('viewPopup', { static: true }) viewPopup: TemplateRef<any>;
  visibleViewPopup: MatDialogRef<TemplateRef<any>>;

  viewPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  viewerData: any = {};
  downloadTemplates(list: any, columnName: any) {
    if (list.CONTENT_EXTN == "mp4") {
      this.openDetailPopup(list, 1);
    } else {
      this.isProcessing = true;
      let docObj = {
        primeIdentifier: list.PRIM_IDENTIFIER,
        tableView: list.tablevwname,
        columnName: columnName
      }
      this.visibleViewPopup = this.dialog.open(this.viewPopup, this.viewPopupConfig);
      this.appService.getDocumentToViewAudit(docObj).subscribe((response: any) => {
        this.isProcessing = false;
        const header = response.headers.get('content-type');
        let binaryData = [];
        this.viewerData = {
          body: response.body,
          contentType: header,
          extn: list.CONTENT_EXTN
        }
      })
    }

  }
  openDetailPopup(list: any, idx: any) {
    this.message.showIndividualContentIfFromTrainingsContentPage = true;
    this.message.individualContentsContentId = list.CONTENT_ID;
    this.router.navigate(['/preview'], {
      state: {
        trainingObj: this.trainingData
      }
    });
  }

  convertKeyToProgrammingFormat(data: any) {
    const convertedObj: { [key: string]: any } = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const formattedKey = key
          .split('_')
          ?.map((item: any, index: any) =>
            index === 0
              ? item.toLowerCase()
              : item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
          )
          .join('');

        convertedObj[formattedKey] = data[key];
      }
    }
    return convertedObj;
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;
  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, content: any) {
    if (viewType == 'overAll') {
      this.message.tableOrView_Name = "TMS_TRAINING_CONTENTS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,CONTENT_NAME,DOCUMENT_NAME,DOCUMENT_VERSION,NO_OF_QUESTIONS_FOR_ASSESSMENT,TOTAL_DURATION,PASS_PERCENTAGE,WAIT_TIME_IN_MINS,CONTENT_DESCRIPTION,CONTENT_EXTN,CONTENT_FILE,CONTENT_SEQ,FOLDER_PATH,IS_QUESTION_CONTENT,DOCUMENT_NO,VERSION,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
      this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,Content Name,Document Name,Document Version,No Of Questions For Assessment,Total Duration,Pass Percentage,Wait Time In Mins,Content Description,Content Extension,Content File,Content Seq,Folder Path,Is Question Content,Document No,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
      this.message.whereClause_AU = " AND TRAINING_ID = " + this.trainingData.trainingId +
        " AND VERSION = " + this.trainingData.version;

      this.message.columnList_Report = "Created Timestamp,End Timestamp,Action,Content Name,Document Name,Document Version,No Of Questions For Assessment,Total Duration,Pass Percentage,Wait Time In Mins,Content Description,Content Extension,Content File,Content Seq,Folder Path,Is Question Content,Document No,Version,Created On,Created By,Updated On,Updated By,Deleted By,Deleted Reason";
      this.message.whereClause_Report = " WHERE TRAINING_ID = " + this.trainingData.trainingId +
        " AND VERSION = " + this.trainingData.version;
      this.message.report_And_Popup_Name = "Training Content Audit Trail";
      this.message.manualEntryDataFields = "EFFECTIVE_DATE,EXPIRATION_DATE";
      this.staticAuditTrailComponent.triggerTrail(content);
    } else {
      this.auditTrail.refNo = content.CONTENT_ID;
      this.auditTrail.gridName = 'TRAINING_CONTENTS';
      this.auditTrail.report_And_Popup_Name = 'Training Content Audit Trail';
      this.dynamicAuditTrailComponent.triggerTrail(content);
    }
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Training Content Report [' + this.trainingData.trainingName + ' ' + this.trainingData.version + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild('fileUploadForBulkQuestion')
  myInputVariable: ElementRef;
  fileUploadPath: any = null;
  fileName: any = null;
  fileExtension: any = null;
  onFileSelectedForBulkQuestions(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      let date = new Date(Date.now());
      let fileName = "TC_" + this.trainingData.trainingId + "_" + `${date.getDate()}${date.getMonth() + 1}${date.getFullYear()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}`;
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      if (extension == "csv") {
        const formData = new FormData();
        formData.append('file', file ?? '');
        formData.append("pageName", "TMS");
        formData.append("fileName", fileName);
        formData.append("extension", extension);
        this.isProcessing = true;
        this.appService.fileUploadToServer(formData)
          .subscribe({
            next: (data: any) => {
              this.isProcessing = false;
              if (data.resultType == "S") {
                this.isFileValid = true;
                this.fileExtension = extension;
                this.fileUploadPath = data.uploadPath;
                this.fileName = data.fileName;
              } else {
                this.myInputVariable.nativeElement.value = "";
                this.isFileValid = false;
                this.fileExtension = null;
                this.fileUploadPath = null;
                this.fileName = null;
                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: data.result,
                    type: data.resultType == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.resultType == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
              }
            }, error: (error) => {
              this.myInputVariable.nativeElement.value = "";
              this.displayMessage = error;
              this.displaySuccessMessage = false;
              this.displayErrorMessage = true;
              this.isProcessing = false;
              throw error;
            }
          })
      } else {
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: "The file should be in csv format",
            type: 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.myInputVariable.nativeElement.value = "";
      }

    } else {
      this.fileExtension = null;
      this.fileUploadPath = null;
      this.fileName = null;
    }
  }

  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }

  addContentAIFunc() {
    this.appService.getAIContentsList(this.trainingData['trainingId'],
      this.trainingData['version']).subscribe((data: any) => {
      })
  }
  private sanitizeContentData(contentData: any): void {
    if (this.isQuestionContent) {
      contentData.documentId = null;
      contentData.documentNo = null;
      contentData.documentName = null;
      contentData.documentVersion = null;
      contentData.contentExtn = null;
      
      this.contentFile = null; 
      this.contentFrom = "";
    } else {
      contentData.noOfQuestionsForAssessment = null;
      contentData.passPercentage = null;
      contentData.questionCount = 0;
    }
  }

  public focusEmpty(): void { console.log(); }
}
